import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyPageContent"] */ "/vercel/path0/src/components/inbound-gpt/legal-pages.tsx");
